const Loader = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <div className="flex space-x-2 text-[50px] font-bold text-[#1b4a78]">
        <span className="opacity-0 animate-fadeIn" style={{ animationDelay: "0s" }}>I</span>
        <span className="opacity-0 animate-fadeIn" style={{ animationDelay: "0.4s" }}>M</span>
        <span className="opacity-0 animate-fadeIn" style={{ animationDelay: "0.8s" }}>A</span>
        <span className="opacity-0 animate-fadeIn" style={{ animationDelay: "1.2s" }}>S</span>
        <span className="opacity-0 animate-fadeIn" style={{ animationDelay: "1.6s" }}>H</span>


      </div>
      <div className="space-x-1 text-[18px] text-gray-400 font-medium">
        <span className="opacity-0 animate-fadeIn" style={{ animationDelay: "0s" }}>I</span>
        <span className="opacity-0 animate-fadeIn" style={{ animationDelay: "0.2s" }}>N</span>
        <span className="opacity-0 animate-fadeIn" style={{ animationDelay: "0.4s" }}>S</span>
        <span className="opacity-0 animate-fadeIn" style={{ animationDelay: "0.6s" }}>U</span>
        <span className="opacity-0 animate-fadeIn" style={{ animationDelay: "0.8s" }}>R</span>
        <span className="opacity-0 animate-fadeIn" style={{ animationDelay: "1.0s" }}>A</span>
        <span className="opacity-0 animate-fadeIn" style={{ animationDelay: "1.2s" }}>N</span>
        <span className="opacity-0 animate-fadeIn" style={{ animationDelay: "1.4s" }}>C</span>
        <span className="opacity-0 animate-fadeIn" style={{ animationDelay: "1.6s" }}>E</span>

      </div>
    </div>
  );
};

export default Loader;
